import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

/* -------------------- Sortable Row -------------------- */
const SortableRow = ({ id, children, isSingle, isFirst, isLast, isEditMode }) => {
  const { setNodeRef, attributes, listeners, transform, transition } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr
      ref={setNodeRef}
      style={style}
      {...attributes}
      className={`
    bg-white overflow-hidden text-xs font-normal
    ${isSingle ? "rounded-bl-xl" : ""}
    ${isFirst && !isSingle ? "rounded-t-xl" : ""}
    ${isLast && !isSingle ? "rounded-bl-xl" : ""}
  `}
    >
      {isEditMode && (
        <td
          className={`p-2 min-w-[32px] text-left cursor-grab active:cursor-grabbing ${
            isSingle
              ? "rounded-tl-xl rounded-bl-xl"
              : `${isFirst ? "rounded-tl-xl" : ""} ${isLast ? "rounded-bl-xl" : ""}`.trim()
          }`}
          {...listeners}
        >
          <img
            src="https://vetic-img.s3.ap-south-1.amazonaws.com/quick_commerce//misc/Icon.png"
            className="w-3 h-3 object-cover shrink-0"
          />
        </td>
      )}
      {children}
    </tr>
  );
};

export default SortableRow;
